module.exports = __webpack_public_path__ + "img/logo-visa.e215ae92.svg";